import { combineReducers } from 'redux'
import getTime from 'date-fns/getTime'

// ACTIONS
export const REGISTER = 'company/candidateList/impressions/REGISTER'
export const SEND = 'company/candidateList/impressions/SEND'
export const CLEAR = 'company/candidateList/impressions/CLEAR'

// ACTION CREATORS
export const register = impression => ({
  type: REGISTER,
  payload: impression,
})

export const send = (companyId, data) => ({
  type: SEND,
  payload: { companyId, data },
})

export const clear = impressions => ({
  type: CLEAR,
  payload: impressions,
})

// REDUCERS
const collection = (state = [], { type, payload }) => {
  switch (type) {
    case REGISTER:
      return [...state, { ...payload, id: getTime(new Date()) }]

    case CLEAR:
      return state.filter(impr => !payload.includes(impr.id))

    default:
      return state
  }
}

export default combineReducers({
  collection,
})
